import createCompanyFormModel from './createCompanyFormModel';
const {
  formField: {
    type_document,
    number_document,
    tradename,
    business_name,
    legal_representative,
    email,
    manager_in_charge,
    economic_activity,
    branch_offices,
    country,
    departament,
    municipaly,
    address_company,
    workplace,
    landline,
    cell_phone,

    // FORMA DE PAGO
    payment_frequency,
    payment_method,
    associated_bank,
    type_account_bank,
    account_number,

    // SEGURIDAD SOCIAL
    sgsst,
    arl,
    constitution_date,
    ley_1429_2010,
    ley_590_2000,
    ley_1607_2012,

    // ARCHIVOS
    rut,
    rut_name_saved_file,
    chamber_of_commerce,
    chamber_of_commerce_name_saved_name,
    bank_certificate,
    bank_certificate_name_saved_name,

    // LOGOS NOMBRE COMERCIAL
    logo_bn_company,
    logo_bn_rz_company_name_saved_file,
    logo_bn_post_company,
    logo_bn_rz_post_company_name_saved_file,

    // LOGOS POST COMERCIAL
    logo_company,
    logo_post_company,
  },
} = createCompanyFormModel;

export default {
  [type_document.name]: '',
  [number_document.name]: '',
  [tradename.name]: '',
  [business_name.name]: '',
  [legal_representative.name]: '',
  [email.name]: '',
  [manager_in_charge.name]: '',
  [economic_activity.name]: '',
  [branch_offices.name]: false,
  [country.name]: '',
  [departament.name]: '',
  [municipaly.name]: '',
  [address_company.name]: '',
  [workplace.name]: '',
  [landline.name]: '',
  [cell_phone.name]: '',
  [payment_frequency.name]: '',
  [payment_method.name]: '',
  [associated_bank.name]: '',
  [type_account_bank.name]: '',
  [account_number.name]: '',
  [sgsst.name]: '',
  [arl.name]: '',
  [constitution_date.name]: null,
  [ley_1429_2010.name]: false,
  [ley_590_2000.name]: false,
  [ley_1607_2012.name]: false,
  [rut.name]: null,
  [rut_name_saved_file.name]: null,
  [chamber_of_commerce.name]: null,
  [chamber_of_commerce_name_saved_name.name]: null,
  [bank_certificate.name]: null,
  [bank_certificate_name_saved_name.name]: null,
  [logo_bn_company.name]: null,
  [logo_bn_rz_company_name_saved_file.name]: null,
  [logo_bn_post_company.name]: null,
  [logo_bn_rz_post_company_name_saved_file.name]: null,
  [logo_company.name]: null,
  [logo_post_company.name]: null,
};
